import { cn } from "../../../../lib/utils";

export function Line({ className }) {
	return (
		<div
			className={cn(
				"w-[32px] laptop:w-[48px] border-2 rounded-full border-white",
				className,
			)}
		/>
	);
}
